import type { EmailLocalePreferenceDTO } from './accountTypes.js';
import {
  isEmailLocaleCode,
  serverEffectiveEmailDefaultLocale as serverEffectiveEmailDefaultLocaleFromPreference,
  type EmailLocaleCode,
} from './emailLocalePreference.js';

export function isDefaultEmailPreference(
  data: EmailLocalePreferenceDTO | undefined,
): boolean {
  if (data === undefined) {
    return true;
  }
  if (data.mode === 'custom') {
    return false;
  }
  return data.mode === 'default' || data.isPlatformDefault;
}

/** True when Default must PUT live UI language (null/stale stored uiLocale). */
export function needsEmailUiLocaleSync(
  storedUiLocale: string | null | undefined,
  liveUiLocale: EmailLocaleCode,
): boolean {
  if (!isEmailLocaleCode(storedUiLocale ?? undefined)) {
    return true;
  }
  return storedUiLocale !== liveUiLocale;
}

/** Coalesce in-flight sync: always keep the latest requested locale. */
export function nextCoalescedEmailLocale(
  _pending: EmailLocaleCode | null,
  incoming: EmailLocaleCode,
): EmailLocaleCode {
  return incoming;
}

/** Re-export generation-aligned Default locale helper. */
export const serverEffectiveEmailDefaultLocale =
  serverEffectiveEmailDefaultLocaleFromPreference;
